import Vconsole from 'vconsole'

let vConsole = null;
if (process.env.VUE_APP_V_CONSOLE !== 'production') {
    vConsole = new Vconsole();
}
export default vConsole
